var B = Object.defineProperty, P = Object.defineProperties;
var d = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var c = (r, s, p) => s in r ? B(r, s, { enumerable: !0, configurable: !0, writable: !0, value: p }) : r[s] = p, o = (r, s) => {
  for (var p in s || (s = {}))
    m.call(s, p) && c(r, p, s[p]);
  if (e)
    for (var p of e(s))
      u.call(s, p) && c(r, p, s[p]);
  return r;
}, n = (r, s) => P(r, d(s));
var l = (r, s) => {
  var p = {};
  for (var t in r)
    m.call(r, t) && s.indexOf(t) < 0 && (p[t] = r[t]);
  if (r != null && e)
    for (var t of e(r))
      s.indexOf(t) < 0 && u.call(r, t) && (p[t] = r[t]);
  return p;
};
import { jsx as I } from "react/jsx-runtime";
import "react";
import { p as y } from "./polymorphic-factory-DufevJAl.js";
import { I as a } from "./Input--FNE961U.js";
import { u as w } from "./use-input-props-TH9VAmBb.js";
const x = {
  __staticSelector: "InputBase",
  withAria: !0
}, f = y((r, s) => {
  const i = w("InputBase", x, r), { inputProps: p, wrapperProps: t } = i, h = l(i, ["inputProps", "wrapperProps"]);
  return /* @__PURE__ */ I(a.Wrapper, n(o({}, t), { children: /* @__PURE__ */ I(a, n(o(o({}, p), h), { ref: s })) }));
});
f.classes = o(o({}, a.classes), a.Wrapper.classes);
f.displayName = "@mantine/core/InputBase";
export {
  f as I
};
